module.exports = __webpack_public_path__ + "static/media/ai2.b8e2d574.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/ai2.jpg
// module id = 53
// module chunks = 0